'use client'

import { CollectionContainer } from '@/components/common/collection/collection-container'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

const highlights = [
  {
    img: '/image/May2025/mceclip12_20.png',
    key: 'polyester',
  },
  {
    img: '/image/May2025/mceclip11_79.png',
    key: 'soft',
  },
  {
    img: '/image/May2025/mceclip10_75.png',
    key: 'absorption',
  },
  {
    img: '/image/May2025/mceclip9_70.png',
    key: 'ventilation',
  },
]

export const HighlightExdryFeature = () => {
  const t = useTranslations()

  return (
    <CollectionContainer className='mb-10 bg-neutral-100 px-4'>
      <h2 className='mb-8 text-center text-3xl font-bold md:text-4xl'>
        {t('tshirt_polo_new_hardcode.exdry.title')}
      </h2>
      <Carousel
        opts={{
          align: 'start',
          loop: true,
        }}
        className='w-full'
      >
        <CarouselContent className='-ml-2 md:-ml-4'>
          {highlights.map((item, idx) => (
            <CarouselItem
              key={idx}
              className='basis-full pl-2 md:basis-1/3 md:pl-4'
            >
              <div className='flex flex-col items-center'>
                <div className='relative aspect-[16/9] w-full'>
                  <Image
                    src={ImageHelper.getImageUrlCdn(item.img)}
                    alt={t(
                      `tshirt_polo_new_hardcode.exdry.features.${item.key}`
                    )}
                    className='rounded-xl object-cover'
                    fill
                  />
                </div>
                <div className='mt-1 px-4 text-center text-sm font-medium text-neutral-700 md:text-base'>
                  {t(`tshirt_polo_new_hardcode.exdry.features.${item.key}`)}
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
    </CollectionContainer>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute left-0 top-1/2 h-7 w-7 -translate-y-1/2 lg:-left-10'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute right-0 top-1/2 h-7 w-7 -translate-y-1/2 lg:-right-10'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
